<hr
  class="ruler"
  [ngClass]="{
    active: step.active,
    completed: step.completed,
    touched: step.touched,
    disabled: step.disabled
  }"
/>
